"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const decorators_js_1 = require("lit/decorators.js");
const lit_1 = require("lit");
const lit_html_1 = require("lit-html");
const control_1 = require("./control");
const class_map_js_1 = require("lit-html/directives/class-map.js");
/**
 * Чекбокс
 */
let SelectField = class SelectField extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Имя поля
         */
        this.name = '';
        /**
         * Надпись
         */
        this.label = '';
        /**
         * Значения селекта
         */
        this.values = {};
        /**
         * Ошибка
         */
        this.error = '';
        this.onChange = this.onChange.bind(this);
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        (_a = this.control) === null || _a === void 0 ? void 0 : _a.registerOnError(() => {
            var _a;
            this.error = ((_a = this.control) === null || _a === void 0 ? void 0 : _a.getError()) || '';
        });
    }
    /**
     * Обрабатывает изменения элемента
     */
    onChange(e) {
        var _a, _b;
        (_a = this.control) === null || _a === void 0 ? void 0 : _a.resetError();
        (_b = this.control) === null || _b === void 0 ? void 0 : _b.setValue(e.target.value);
    }
    getValuesMap() {
        return Object.keys(this.values).reduce((carry, key) => {
            // @ts-ignore
            carry.push({ key: key, value: this.values[key] });
            return carry;
        }, []);
    }
    /**
     * Возвращает представление
     */
    render() {
        const label = this.label
            ? (0, lit_html_1.html) `<label class="input-label">${this.label}</label>`
            : null;
        return (0, lit_html_1.html) `
            <div class="input-group h-100">
                ${label}
                <div class="select">
                    <select class="art-uikit form-control form-select ${(0, class_map_js_1.classMap)({ 'is-invalid': !!this.error })}" @change="${this.onChange}">
                        ${this.getValuesMap().map((value) => {
            var _a;
            return (0, lit_html_1.html) `
                        <option value="${value.key}" ?selected="${value.key === ((_a = this.control) === null || _a === void 0 ? void 0 : _a.getValue())}">${value.value}</option>
                    `;
        })}
                    </select>
                    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L4 4L7 1" stroke="black"/>
                    </svg>
                </div>
                <div class="art-uikit invalid-feedback">${this.error}</div>
            </div>
        `;
    }
};
__decorate([
    (0, decorators_js_1.property)({ type: String }),
    __metadata("design:type", String)
], SelectField.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String }),
    __metadata("design:type", String)
], SelectField.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: control_1.Control }),
    __metadata("design:type", control_1.Control)
], SelectField.prototype, "control", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", Object)
], SelectField.prototype, "values", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", String)
], SelectField.prototype, "error", void 0);
SelectField = __decorate([
    (0, decorators_js_1.customElement)('art-select-field'),
    __metadata("design:paramtypes", [])
], SelectField);
